module.exports = __FOREMAN_VENDOR__BABEL_POLYFILL__;


//////////////////
// WEBPACK FOOTER
// external "__FOREMAN_VENDOR__BABEL_POLYFILL__"
// module id = babel-polyfill
// module chunks = 32